// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Notifications-headerRow-WKjK2 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    gap: 12px;
    margin-bottom: 18px;
}

.Notifications-pageTitle-HoiQm {
    font-size: 22px;
    font-weight: 700;
    color: #1F2733;
    margin: 0;
    font-family: 'Poppins', sans-serif;
}

.Notifications-markAllBtn-IC0e2 {
    white-space: nowrap;
}

.Notifications-notificationList-y9kEo {
    list-style: none;
    margin: 0;
    padding: 0;
}

.Notifications-notificationItem-ArgsW {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
    gap: 14px;
    padding: 16px 18px;
    border: 1px solid #ECECEC;
    border-radius: 14px;
    margin-bottom: 12px;
    background: #fff;
    cursor: pointer;
    -webkit-transition: border-color .15s ease, background .15s ease;
    transition: border-color .15s ease, background .15s ease;
}

.Notifications-notificationItem-ArgsW:hover {
    border-color: #D32F2F;
}

.Notifications-notificationItemUnread-nbj2f {
    background: #FFF6F4;
    border-color: #F3CFC9;
}

.Notifications-iconCircle-Igo8z {
    -webkit-box-flex: 0;
        -ms-flex: 0 0 auto;
            flex: 0 0 auto;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: #E0E0E0;
    color: #6B7280;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    font-size: 18px;
}

.Notifications-iconCircleUnread-b2V_E {
    background: #D32F2F;
    color: #fff;
}

.Notifications-notificationBody-OkE5r {
    -webkit-box-flex: 1;
        -ms-flex: 1 1 auto;
            flex: 1 1 auto;
    min-width: 0;
}

.Notifications-notificationTitle-R7s0x {
    font-size: 15px;
    font-weight: 600;
    color: #1F2733;
    margin: 0 0 4px;
}

.Notifications-notificationTitleUnread-dkl9N {
    font-weight: 700;
}

.Notifications-notificationPreview-cwC10 {
    font-size: 14px;
    color: #5C6470;
    margin: 0 0 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.Notifications-notificationFull-ZcwuP {
    font-size: 14px;
    color: #3A4250;
    margin: 0 0 6px;
    white-space: pre-wrap;
}

.Notifications-notificationTime-owE45 {
    font-size: 12px;
    color: #9AA1AC;
}

.Notifications-unreadDot-C9YeU {
    -webkit-box-flex: 0;
        -ms-flex: 0 0 auto;
            flex: 0 0 auto;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #D32F2F;
    margin-top: 6px;
}

.Notifications-loadMoreWrap-SndHz {
    text-align: center;
    margin-top: 8px;
}

.Notifications-emptyText-u7xbH {
    text-align: center;
    color: #9AA1AC;
    font-size: 15px;
    padding: 40px 0;
}
`, "",{"version":3,"sources":["webpack://./src/routes/notifications/Notifications.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gEAAwD;IAAxD,wDAAwD;AAC5D;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAc;QAAd,kBAAc;YAAd,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAc;QAAd,kBAAc;YAAd,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAc;QAAd,kBAAc;YAAd,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,eAAe;AACnB","sourcesContent":[".headerRow {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    margin-bottom: 18px;\n}\n\n.pageTitle {\n    font-size: 22px;\n    font-weight: 700;\n    color: #1F2733;\n    margin: 0;\n    font-family: 'Poppins', sans-serif;\n}\n\n.markAllBtn {\n    white-space: nowrap;\n}\n\n.notificationList {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n.notificationItem {\n    display: flex;\n    align-items: flex-start;\n    gap: 14px;\n    padding: 16px 18px;\n    border: 1px solid #ECECEC;\n    border-radius: 14px;\n    margin-bottom: 12px;\n    background: #fff;\n    cursor: pointer;\n    transition: border-color .15s ease, background .15s ease;\n}\n\n.notificationItem:hover {\n    border-color: #D32F2F;\n}\n\n.notificationItemUnread {\n    background: #FFF6F4;\n    border-color: #F3CFC9;\n}\n\n.iconCircle {\n    flex: 0 0 auto;\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    background: #E0E0E0;\n    color: #6B7280;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 18px;\n}\n\n.iconCircleUnread {\n    background: #D32F2F;\n    color: #fff;\n}\n\n.notificationBody {\n    flex: 1 1 auto;\n    min-width: 0;\n}\n\n.notificationTitle {\n    font-size: 15px;\n    font-weight: 600;\n    color: #1F2733;\n    margin: 0 0 4px;\n}\n\n.notificationTitleUnread {\n    font-weight: 700;\n}\n\n.notificationPreview {\n    font-size: 14px;\n    color: #5C6470;\n    margin: 0 0 6px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n}\n\n.notificationFull {\n    font-size: 14px;\n    color: #3A4250;\n    margin: 0 0 6px;\n    white-space: pre-wrap;\n}\n\n.notificationTime {\n    font-size: 12px;\n    color: #9AA1AC;\n}\n\n.unreadDot {\n    flex: 0 0 auto;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background: #D32F2F;\n    margin-top: 6px;\n}\n\n.loadMoreWrap {\n    text-align: center;\n    margin-top: 8px;\n}\n\n.emptyText {\n    text-align: center;\n    color: #9AA1AC;\n    font-size: 15px;\n    padding: 40px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerRow": `Notifications-headerRow-WKjK2`,
	"pageTitle": `Notifications-pageTitle-HoiQm`,
	"markAllBtn": `Notifications-markAllBtn-IC0e2`,
	"notificationList": `Notifications-notificationList-y9kEo`,
	"notificationItem": `Notifications-notificationItem-ArgsW`,
	"notificationItemUnread": `Notifications-notificationItemUnread-nbj2f`,
	"iconCircle": `Notifications-iconCircle-Igo8z`,
	"iconCircleUnread": `Notifications-iconCircleUnread-b2V_E`,
	"notificationBody": `Notifications-notificationBody-OkE5r`,
	"notificationTitle": `Notifications-notificationTitle-R7s0x`,
	"notificationTitleUnread": `Notifications-notificationTitleUnread-dkl9N`,
	"notificationPreview": `Notifications-notificationPreview-cwC10`,
	"notificationFull": `Notifications-notificationFull-ZcwuP`,
	"notificationTime": `Notifications-notificationTime-owE45`,
	"unreadDot": `Notifications-unreadDot-C9YeU`,
	"loadMoreWrap": `Notifications-loadMoreWrap-SndHz`,
	"emptyText": `Notifications-emptyText-u7xbH`
};
module.exports = ___CSS_LOADER_EXPORT___;
